var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { of as observableOf } from 'rxjs';
import { filter, withLatestFrom, tap, takeUntil, catchError } from 'rxjs/operators';
import { HttpClient, HttpEventType, HttpHeaders, HttpRequest } from '@angular/common/http';
import { LoopBackConfig } from '@careapp/angular-sdk';
import { Actions, Effect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import * as actions from '../actions/file-upload.actions';
import * as selectors from '../reducers/index';
var FileUploadEffects = /** @class */ (function () {
    function FileUploadEffects(store, actions$, http) {
        var _this = this;
        this.store = store;
        this.actions$ = actions$;
        this.http = http;
        this.uploadStart = this.actions$
            .ofType(actions.REQUEST_FILE_UPLOAD_START).pipe(withLatestFrom(this.store.select(selectors.getAuthenticationState), this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS))), tap(function (_a) {
            var source = _a[0], state = _a[1], organisationId = _a[2];
            _this.createRequest(source, state, organisationId).pipe(takeUntil(_this.actions$.ofType(actions.REQUEST_FILE_UPLOAD_CANCEL).pipe(filter(function (s) {
                return s.payload.id === source.payload.id;
            }))), catchError(function (err) {
                return observableOf(new actions.ResponseFileUploadErrorAction(err));
            }))
                .subscribe(function (event) {
                switch (event.type) {
                    case HttpEventType.Response:
                        return _this.store.dispatch(new actions.ResponseFileUploadCompleteAction({
                            id: source.payload.id,
                            type: source.payload.type,
                            response: event.body
                        }));
                    case HttpEventType.Sent:
                    case HttpEventType.UploadProgress:
                    case HttpEventType.ResponseHeader:
                    case HttpEventType.DownloadProgress:
                        return _this.store.dispatch(new actions.ResponseFileUploadProgressAction({
                            id: source.payload.id,
                            progress: _this.progress(event)
                        }));
                    case actions.RESPONSE_FILE_UPLOAD_ERROR:
                        return _this.store.dispatch(event);
                }
                throw {
                    id: source.payload.id,
                    response: event.body
                };
            });
        }));
    }
    FileUploadEffects.prototype.progress = function (event) {
        var loaded = event.loaded || 0;
        var total = event.total || 100;
        var percent = 100 * loaded / total;
        switch (event.type) {
            case HttpEventType.UploadProgress:
                percent = percent * 0.75;
                break;
            case HttpEventType.ResponseHeader:
                percent = 75;
                break;
            case HttpEventType.DownloadProgress:
                percent = 75 + percent * 0.25;
                break;
            case HttpEventType.Response:
                percent = 100;
                break;
        }
        return percent;
    };
    FileUploadEffects.prototype.buildFormData = function (file) {
        var formData = new FormData();
        formData.append('file[]', file);
        return formData;
    };
    FileUploadEffects.prototype.createRequest = function (source, state, organisationId) {
        var request = new HttpRequest('POST', LoopBackConfig.getPath() +
            '/' +
            LoopBackConfig.getApiVersion() +
            ("/organisations/" + organisationId + "/" + (source.payload.url || 'upload')), this.buildFormData(source.payload.file), {
            responseType: 'json',
            reportProgress: true,
            headers: new HttpHeaders().set('Authorization', state.auth.id)
        });
        return this.http.request(request);
    };
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], FileUploadEffects.prototype, "uploadStart", void 0);
    return FileUploadEffects;
}());
export { FileUploadEffects };
